import {ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, withComponentInputBinding} from '@angular/router';

import { routes } from './app.routes';
import {provideHttpClient, withInterceptors} from "@angular/common/http";
import {provideAnimations} from "@angular/platform-browser/animations";
import {JwtModule} from "@auth0/angular-jwt";
import {DialogService} from "primeng/dynamicdialog";
import {ConfirmationService, MessageService} from "primeng/api";
import {DatePipe} from "@angular/common";
import {jwtInterceptor} from "./core/middlewares/jwt.interceptor";
import {TerminalService} from "primeng/terminal";
import {providePrimeNG} from "primeng/config";
import {definePreset} from "@primeng/themes";
import Aura from "@primeng/themes/aura";

// Preset ALIMA : base Aura + palette primaire #004F78 (bleu marine BCEAO/UEMOA), identique à alima-client
const AlimaPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50:  '#e8f3f9',
      100: '#b9d8ee',
      200: '#8abde2',
      300: '#5ba1d7',
      400: '#2c86cb',
      500: '#004F78',
      600: '#003d5e',
      700: '#002c44',
      800: '#001b2a',
      900: '#000a10',
      950: '#000408',
    }
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([jwtInterceptor])),
    provideAnimations(),
    providePrimeNG({
      theme: {
        preset: AlimaPreset,
        options: {
          darkModeSelector: '.dark',
          cssLayer: {
            name: 'primeng',
            order: 'reset, primeng'
          }
        }
      }
    }),
    importProvidersFrom([JwtModule.forRoot({})]),
    DialogService,
    MessageService,
    TerminalService,
    ConfirmationService,
    DatePipe
  ]
};
